import { Button } from "@/components/ui/button";
import { DataTableColumnHeader } from "../../components/ui/database-column-header";
import { useNavigate } from "react-router-dom";
import { HiTrash } from "react-icons/hi2";
import { useRemoveContractLeads } from "./useRemoveContractLeads";
import { formatDate2, toPascalCase } from "../../utils/helpers";

function DeleteAction({ contract }) {
  const { mutate: removeLead } = useRemoveContractLeads();
  const proposalId = contract.id;
  const searchType = contract.searchType;

  return (
    <Button
      variant="ghost"
      className="h-8 w-8 p-0"
      onClick={() => removeLead({ proposalId, searchType })}
    >
      <HiTrash className="text-gray-600" />
      <span className="sr-only">Delete</span>
    </Button>
  );
}

function RowComponent({ row, children }) {
  const navigate = useNavigate();
  const contract = row.original;

  return (
    <div
      className="cursor-pointer"
      onClick={() => navigate(`/contract/sled/${contract.id}`)}
    >
      {children}
    </div>
  );
}

export const sledColumns = [
  {
    accessorKey: "title",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title="Title"
        className="w-[400px]"
      />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div className="font-medium">{toPascalCase(row.getValue("title"))}</div>
      </RowComponent>
    ),
  },
  {
    accessorKey: "dueDate",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Deadline" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        {formatDate2(row.getValue("dueDate"))}
      </RowComponent>
    ),
  },
  {
    accessorKey: "jurisdiction",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Jurisdiction" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div>{toPascalCase(row.getValue("jurisdiction"))}</div>
      </RowComponent>
    ),
  },
  {
    accessorKey: "type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Type" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        <div>{row.getValue("type")}</div>
      </RowComponent>
    ),
  },
  {
    accessorKey: "level",

    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Level" />
    ),
    cell: ({ row }) => (
      <RowComponent row={row}>
        {row.getValue("level") === "nan" ? null : (
          <div>{toPascalCase(row.getValue("level"))}</div>
        )}
      </RowComponent>
    ),
  },
  {
    id: "delete",
    header: "Delete",
    cell: ({ row }) => <DeleteAction contract={row.original} />,
    className: "sticky-col w-[100px]",
  },
];
